import moment from 'moment';

/**
 * Format a ISO datetime string as a date with the appropriate formatter string
 * @param {string} iso_datetime: The timestamp to format
 * @param {string} format_string: The string to configure the desired format
 * @param {object} dateTimeOptionsConfig: Optional date time config object
 * @returns {string} The formatted date string
 */
/* eslint-disable complexity */
export function formatISODateTime(iso_datetime, format_string = null) {
    const defaultFormatString = 'DD-MMM-YYYY';
    let out = '';

    try {
        let datetimeOptions;

        // Added throw eliminates additional unecessary execution
        if (iso_datetime.indexOf('undefined') > -1) {
            throw 'iso_datetime has an undefined property';  // eslint-disable-line no-throw-literal
        }

        if (typeof this.ctx.core !== 'undefined') {
            datetimeOptions = this.ctx.core.featureConfigs.datetimeOptions;
        } else {
            datetimeOptions = this.ctx.state.core.featureConfigs.datetimeOptions;
        }

        moment.updateLocale('en', {
            monthsShort: datetimeOptions.monthsShort,
            months: datetimeOptions.months
        });

        // We need to add leading zeros to months and days that are not two digits
        let iso_datetime_array = iso_datetime.split('-');
        const leadingZero = '0';

        for (let i = 0; i < iso_datetime_array.length; i++) {
            if (iso_datetime_array[i].length === 1) {
                iso_datetime_array[i] = leadingZero.concat(iso_datetime_array[i]);
            }
        }

        // Format iso_datetime to initial format e.g. 1999-12-31
        iso_datetime = iso_datetime_array.join('-');

        const formatString = format_string || datetimeOptions.dateFormatString || defaultFormatString;
        const utc = moment(iso_datetime).utc();

        out = utc.format(formatString);
    } catch (e) {
        console.warn('~~~ format_iso_datetime: ', e);
    } finally {
        // If the try thows, the variable out will still be set to an empty string
        if (out === '' && _.get(this, 'ctx')) {
            out = this.ctx.core.localizations.containers.chromeLocalization.iso_datetime_unavailable;
        }
    }

    return out;
}

export default formatISODateTime;
